export default {"src":"/_next/static/media/10-lat-logo.7edd69b6.svg","height":30,"width":172};